import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { EmptyState, LoadingGrid } from "@/components/bits";
import api from "@/lib/api";

export default function Blog() {
  const [blogs, setBlogs] = useState(null);

  useEffect(() => {
    api.get("/public/blogs").then(({ data }) => setBlogs(data.blogs)).catch(() => setBlogs([]));
  }, []);

  return (
    <div className="navy-bg min-h-screen pt-32 pb-24" data-testid="blog-page">
      <div className="max-w-5xl mx-auto px-6">
        <p className="text-xs font-bold uppercase tracking-widest text-[#F5A623] mb-3">Insights</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white mb-4">The Job Spring Blog</h1>
        <p className="text-slate-300 mb-14 max-w-2xl">Hiring playbooks, HR technology insights and platform updates from the Job Spring team.</p>
        {!blogs ? (
          <LoadingGrid count={3} />
        ) : blogs.length === 0 ? (
          <EmptyState title="No posts yet" description="New articles will appear here soon." testId="blog-empty" icon={BookOpen} />
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {blogs.map((b) => (
              <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-list-${b.slug}`}>
                <div className="bg-white/5 border border-white/10 rounded-2xl p-7 hover:bg-white/10 transition-colors h-full">
                  <p className="text-[11px] text-slate-400">
                    {new Date(b.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })} · {b.author}
                  </p>
                  <h2 className="font-heading font-semibold text-xl text-white mt-2">{b.title}</h2>
                  <p className="text-sm text-slate-300 mt-3 leading-relaxed">{b.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
